import React from 'react'

import { CallUsBlock } from '@ally/ally-login'
import {
  Button,
  Modal,
  Space,
  TextHeading,
  useModalContext,
} from '@ally/metronome-ui'

import { useHostServices } from '../HostServices'

const headingRef = React.createRef<HTMLHeadingElement>()

const ModalContent: React.FC = () => {
  const { featureFlags } = useHostServices()

  return (
    <>
      <Space mb="md">
        <TextHeading tag="h1" size="md" tabIndex={-1} ref={headingRef}>
          Give us a call.
        </TextHeading>
      </Space>
      <Space mb="md">
        <CallUsBlock variation={featureFlags.variation} />
      </Space>
    </>
  )
}

interface ModalTriggerComponentProps {
  triggerContent: string
}

const ModalTriggerComponent: React.FC<ModalTriggerComponentProps> = ({
  triggerContent,
}) => {
  const { setOpen } = useModalContext()

  return (
    <Button
      allytmln="Call Us Modal"
      variant="link"
      text={triggerContent}
      onClick={(): void => setOpen(true)}
    />
  )
}

interface CallUsModalProps {
  triggerContent?: string
}

export const CallUsModal: React.FC<CallUsModalProps> = ({
  triggerContent = 'call',
}) => (
  <Modal
    content={<ModalContent />}
    trigger={<ModalTriggerComponent triggerContent={triggerContent} />}
  />
)
